import { useState } from 'react'
import moment from 'moment'
import classnames from 'classnames'

import Checkbox from '@components/Checkbox'
import Button from '@components/Button'
import { THINX_TIME_FORMAT } from 'shared/time-utilites'
import FormsyInput from '@components/Textfield/withFormsy'
import TermsAndConditions from './TermsAndConditions'
import { RateCurrency } from 'shared/price-utilities'

import styles from '../styles.module.scss'

const TermsLabelText = ({ onClick }) => (
    <div className={styles.termsConditionsLink}>
        <T>subscription.purchase.terms.conditions.label</T>
        <Button
            btnStyle="link"
            size="small"
            className={classnames('ml-1', styles.termsConditionsLink)}
            onClick={onClick}>
            <T>subscription.purchase.terms.conditions.link</T>
        </Button>
    </div>
)

const FooterSection = ({ total, loading, disabled, onSubmit }) => {
    const [termsAcceptedDate, setTermsAcceptedDate] = useState(null)
    const [showTermsConditions, setShowTermsConditions] = useState(false)

    const acceptTermsHandler = event => {
        const { checked } = event?.target

        if (checked) {
            setTermsAcceptedDate(moment().format(THINX_TIME_FORMAT))
        } else {
            setTermsAcceptedDate(null)
        }
    }

    const toggleTermsConditions = e => {
        e?.preventDefault()
        setShowTermsConditions(!showTermsConditions)
    }

    return (
        <>
            {showTermsConditions && (
                <TermsAndConditions
                    closeModal={toggleTermsConditions}
                    onAcceptTermsHandler={() => setTermsAcceptedDate(moment().format(THINX_TIME_FORMAT))}
                />
            )}
            <div>
                <div
                    className={classnames(
                        'mb-3',
                        'd-flex',
                        'align-items-baseline',
                        'justify-content-sm-end',
                        styles.footerTotal
                    )}>
                    <span className="mr-2">
                        <T>subscripition.purchase.pay.label.total</T>
                    </span>
                    <h2>
                        <RateCurrency value={total} currency="$" />
                    </h2>
                </div>
                <div className="d-sm-flex justify-content-between align-items-center">
                    <FormsyInput value={termsAcceptedDate} name="termsAcceptedDate" type="hidden" />
                    <Checkbox
                        required
                        name="acceptTerms"
                        checked={termsAcceptedDate}
                        onChange={acceptTermsHandler}
                        className={styles.termsConditionsCheckbox}>
                        <TermsLabelText onClick={toggleTermsConditions} />
                    </Checkbox>
                    <Button
                        isLoading={loading}
                        onClick={onSubmit}
                        btnStyle="primary"
                        type="submit"
                        disabled={!termsAcceptedDate || disabled}>
                        <T>subscription.purchase.label.buy</T>
                    </Button>
                </div>
            </div>
        </>
    )
}

export default FooterSection
